module.exports = __webpack_public_path__ + "static/media/language-selection.351a63a7.png";